require('./bootstrap');

require('./components/mobile-menu');
require('./components/generic');
require('./components/anchor-hash');
require('./components/preload');
require('./components/blog-filter');
require('./components/gallery');
require('./components/carousel');
require('./components/questions');
require('./components/input-width');
require('./components/search-bar');
require('./components/select-custom');
require('./components/promo-block');
require('./components/load-more');
require('./components/article-more-information');
require('./components/local-clinics');
require('./components/map');
require('./components/hubspot-forms');
require('./components/exit-intent');
//require('./components/single-location-page');
require('./components/share');
